var _rect, _rect2, _circle, _circle2, _circle3, _circle4, _path, _rect3, _rect4, _line, _line2, _rect5, _rect6, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCar3Blue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "#75ECCF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 43,
    width: 56,
    height: 7,
    rx: 2,
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 46.5,
    r: 4.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 46.5,
    r: 1.5,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 46.5,
    r: 4.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 46.5,
    r: 1.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7446 20.6648C18.8864 20.2662 19.2637 20 19.6867 20H52.3133C52.7363 20 53.1136 20.2662 53.2554 20.6648L57.5249 32.6648C57.7566 33.3158 57.2738 34 56.5828 34H15.4172C14.7262 34 14.2434 33.3158 14.4751 32.6648L18.7446 20.6648Z",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 28,
    width: 6,
    height: 4,
    rx: 1,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 28,
    width: 6,
    height: 4,
    rx: 1,
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.6708,
    y1: 30.2236,
    x2: 13.2236,
    y2: 33.3292,
    stroke: "black",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 3.97214,
    y2: -0.5,
    transform: "matrix(-0.447214 0.894427 0.894427 0.447214 61 30)",
    stroke: "black",
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 46,
    width: 21,
    height: 0.5,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 47,
    width: 21,
    height: 0.5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.852 56.997C42.8803 56.997 42.4333 56.2868 42.0743 55.7166C41.7291 55.1732 41.5375 54.9171 41.2338 54.9171C40.93 54.9171 40.7367 55.1732 40.395 55.7166C40.036 56.2868 39.5907 56.997 38.6173 56.997C37.6439 56.997 37.1986 56.2868 36.8396 55.7166C36.4945 55.1732 36.3046 54.9171 36.0009 54.9171C35.6971 54.9171 35.5055 55.1732 35.1604 55.7196C34.8014 56.2898 34.3544 57 33.3827 57C32.411 57 31.964 56.2898 31.605 55.7196C31.2598 55.1762 31.07 54.9201 30.7662 54.9201C30.4625 54.9201 30.2692 55.1762 29.9274 55.7196C29.5684 56.2898 29.1214 57 28.1498 57C27.1781 57 26.7311 56.2898 26.3721 55.7196C26.0269 55.1762 25.8371 54.9201 25.5333 54.9201C25.3919 54.9201 25.2562 54.8716 25.1562 54.7854C25.0562 54.6991 25 54.5821 25 54.46C25 54.338 25.0562 54.221 25.1562 54.1347C25.2562 54.0485 25.3919 54 25.5333 54C26.505 54 26.952 54.7087 27.311 55.2804C27.6562 55.8238 27.846 56.0799 28.1498 56.0799C28.4535 56.0799 28.6468 55.8238 28.9885 55.2804C29.3475 54.7087 29.7945 54 30.7662 54C31.7379 54 32.1849 54.7087 32.5439 55.2804C32.8891 55.8238 33.0806 56.0799 33.3827 56.0799C33.6847 56.0799 33.8797 55.8238 34.2215 55.2804C34.5805 54.7087 35.0275 54 35.9991 54C36.9708 54 37.4178 54.7087 37.7768 55.2804C38.122 55.8238 38.3136 56.0799 38.6156 56.0799C38.9176 56.0799 39.1144 55.8238 39.4544 55.2804C39.8151 54.7087 40.2604 54 41.2321 54C42.2037 54 42.6525 54.7087 43.0115 55.2804C43.3566 55.8238 43.5465 56.0799 43.8502 56.0799C44.154 56.0799 44.3473 55.8238 44.689 55.2804C45.048 54.7087 45.495 54 46.4667 54C46.6081 54 46.7438 54.0485 46.8438 54.1347C46.9438 54.221 47 54.338 47 54.46C47 54.5821 46.9438 54.6991 46.8438 54.7854C46.7438 54.8716 46.6081 54.9201 46.4667 54.9201C46.1629 54.9201 45.9696 55.1762 45.6279 55.7196C45.2707 56.2868 44.8254 56.997 43.852 56.997Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar3Blue);
export default __webpack_public_path__ + "static/media/Car3_Blue.08f2d44a60f613bb57f4ff1878fecad9.svg";
export { ForwardRef as ReactComponent };